$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = LANG.aguarde;

	$.cookieBar({
		message: LANG.cookies_txt,
		acceptText: LANG.cookies_btn,
		fixed: true,
		bottom: true,
		policyButton: true,
		policyText: LANG.cp_txt,
		policyURL: LANG.cp_url,
	});

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}


	if ($('.mh').length) {
		$('.mh').matchHeight(false);
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('.loading-container').fadeOut();
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	/**
	 * Fade loading images
	 */
	/*var load_images_bg = $('body').find('.load-img:not(.loaded), .load-img-uncover:not(.loaded)');
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) {
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	}*/

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) { //is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) { //is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else { //is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');

	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	/**
	 * Exemplo de submissão de form
	 */
	$('body').on('click', '#send-suggestion', function (e) {
		e.preventDefault();

		var form = $('form.suggestion-form');
		var fields = form.serialize();
		var action = form.attr('action');

		if (checkPolicy(form)) {
			var send = true;
			form.find('#feedback__suggestion').removeClass().html('');
			form.find('.invalid').removeClass('invalid');

			if ($('#email').length) {
				var email = $('#email').val();
				if (!IsEmail(email)) {
					form.find('#email').parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.email_invalido).addClass('error').fadeIn("fast");
					send = false;
				}
			}

			var required = form.find('.required');
			required.each(function () {
				if ($.trim($(this).val()) == '' || $.trim($(this).val()) == $(this)[0].defaultValue) {
					$(this).parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.preencha_os_campos_em_falta).addClass('error').fadeIn("fast");
					send = false;
				}
			});
			if (send) {
				$.blockUI();
				$.ajax({
					url: action,
					type: 'POST',
					data: fields,
					dataType: 'json',
					success: function (r) {
						if (r.class == 'ok') {
							form[0].reset();
						}
						$('#feedback__suggestion').show().addClass(r.class).html(r.message);
						$.unblockUI();
					},
					error: function (r) {
						$('#feedback__suggestion').show().addClass('error').html(LANG.ocorreu_um_erro);
						$.unblockUI();
					}
				});
			}
		} else {
			$('#feedback__suggestion').show().addClass('error').html(LANG.accept_privacy_policy);
			$.unblockUI();
		}
	});

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	if ($(".marquee-text").length) {
		let tween = gsap.to(".marquee-text", { xPercent: -100, repeat: -1, duration: 90, ease: "linear" }).totalProgress(0.5);
	}

	if ($(".rotate-right-container").length) {

		$(".rotate-right-container")
			.find('.info-app-wrap')
			.clone()
			.appendTo('.rotate-right-container');

		$(".rotate-left-container")
			.find('.info-app-wrap')
			.clone()
			.appendTo('.rotate-left-container');

		let tweenright = gsap.to(".rotate-right-container .info-app-wrap", { xPercent: 100, repeat: -1, duration: 40, ease: "linear" }).totalProgress(0.5);

		let tweenleft = gsap.to(".rotate-left-container .info-app-wrap", { xPercent: -100, repeat: -1, duration: 40, ease: "linear" }).totalProgress(0.5);
	}

	/* PARTNERS */
	if ($(".rotate-right-container").length) {

		$(".rotate-right-container")
			.find('.info-app-partners')
			.clone()
			.appendTo('.rotate-right-container');

		let tweenright = gsap.to(".rotate-right-container .info-app-partners", { xPercent: 100, repeat: -1, duration: 40, ease: "linear" }).totalProgress();
	}


	/* gsap.to("#info-app-list", {
		scrollTrigger: {
			trigger: "#sticky-text",
			start: "top center",
			end: "bottom top",
			scrub: true,
			pin: true,
			markers: true,
		},
	}); */

	/* if($('#sticky-text').length && window_w > 820){
		ScrollTrigger.create({
			trigger: "#sticky-text",
			start: "top center", 
			end: 'bottom-=45% center',
			pin: true, 
			endTrigger: '#info-app-list'
		  });
	} */

	/**
	 * ScrollSmoother
	 */
	if (!Modernizr.touchevents) {
		ScrollSmoother.create({
			smooth: 0.8,
			effects: true,
			smoothTouch: 0.1
		});
	}


	/* gsap.utils.toArray(".modalidade-item").forEach((panel, i) => {
		
	  }); */

	/*  if($('.modalidades-list').length){
	   gsap.to(".modalidade-item-1", { scale: 0.65,
		   scrollTrigger: {
			   trigger: ".modalidade-item-1",
			   start: 'bottom-=200 center',
			   scrub: true,
			   end: 'top+=70 center',
			   pin: true,
			   pinSpacing: false,
			   endTrigger: '.modalidade-item-3'
		   }
	   });
	   if(window_w > 1280){
		   gsap.to(".modalidade-item-2", { scale: 0.8,
			   scrollTrigger: {
				   trigger: ".modalidade-item-2",
				   start: 'bottom-=290 center',
				   scrub: true,
				   end: 'top+=70 center',
				   pin: true,
				   pinSpacing: false,
				   endTrigger: '.modalidade-item-3'
			   }
		   });
	   }
	   else if(window_w > 1024){
		   gsap.to(".modalidade-item-2", { scale: 0.8,
			   scrollTrigger: {
				   trigger: ".modalidade-item-2",
				   start: 'bottom-=250 center',
				   scrub: true,
				   end: 'top+=70 center',
				   pin: true,
				   pinSpacing: false,
				   endTrigger: '.modalidade-item-3'
			   }
		   });
	   }
	   else{
		   gsap.to(".modalidade-item-2", { scale: 0.8,
			   scrollTrigger: {
				   trigger: ".modalidade-item-2",
				   start: 'bottom-=250 center',
				   scrub: true,
				   end: 'top+=90 center',
				   pin: true,
				   pinSpacing: false,
				   endTrigger: '.modalidade-item-3'
			   }
		   });
	   }
	 } */


	//Planos
	if ($('.accordion').length) {
		if (!window.location.hash) {
			//primeiro elemento
			// $(this).find(".accordion-span-default").addClass('down');
			// $(this).find(".accordion-desc-default").show();
		}
		$('.accordion').find('.accordion-title').on('click', function () {

			if ($(this).find('.accordion-arrow.down').length) {
				$('.accordion').removeClass('open');
				$('.accordion').find('.accordion-arrow.down').removeClass('down');
				$(this).find('.accordion-desc').slideUp(200);
				$.bbq.pushState("#close");
			} else {
				$.bbq.pushState("#" + $(this).attr("data-url"));
			}
		});

		$(window).bind("hashchange", function (event) {

			var $target = $('#accordion-' + decodeURIComponent($.param.fragment()));

			if ($target.length) {
				$target.find('.accordion-desc').slideToggle(200, function () {
					$("body, html").stop().delay(100).animate({ scrollTop: ($target.offset().top - 160) }, 400);
				});
				$('.accordion-title').not($target).removeClass('open');
				$target.toggleClass('open');
				var thisspan = $target.find('span');
				$('.accordion-title span').not(thisspan).removeClass('down');
				$(thisspan).toggleClass('down');
				$(".accordion-desc:visible").not($target.find('.accordion-desc')).slideUp(200);
			}

			var $target_separador = $('#separador-' + decodeURIComponent($.param.fragment()));

			if ($target_separador.length) {
				$("body, html").stop().delay(100).animate({ scrollTop: ($target_separador.offset().top) }, 400);
			}

		}).trigger("hashchange");
	}


	//FAQS
	if ($('#accordion').length) {
		if (!window.location.hash) {
			$("#accordion-span-default").addClass('down');
			$("#accordion-desc-default").show();
		}
		$('#accordion').find('.accordion-title').on('click', function () {
			if ($(this).find('.accordion-arrow.down').length) {
				$(this).removeClass('open');
				$(this).find('.accordion-arrow.down').removeClass('down');
				$(this).find('.accordion-desc').slideUp(200);
				$.bbq.pushState("#close");
			} else {
				$.bbq.pushState("#" + $(this).attr("data-url"));
			}
		});

		$(window).bind("hashchange", function (event) {

			var $target = $('#accordion-' + decodeURIComponent($.param.fragment()));

			if ($target.length) {
				$target.find('.accordion-desc').slideToggle(200, function () {
					$("body, html").stop().delay(100).animate({ scrollTop: ($target.offset().top - 160) }, 400);
				});
				$('.accordion-title').not($target).removeClass('open');
				$target.toggleClass('open');
				var thisspan = $target.find('span');
				$('.accordion-title span').not(thisspan).removeClass('down');
				$(thisspan).toggleClass('down');
				$(".accordion-desc:visible").not($target.find('.accordion-desc')).slideUp(200);
			}

			var $target_separador = $('#separador-' + decodeURIComponent($.param.fragment()));

			if ($target_separador.length) {
				$("body, html").stop().delay(100).animate({ scrollTop: ($target_separador.offset().top) }, 400);
			}

		}).trigger("hashchange");
	}

	var swiper4 = new Swiper(".reviews-slider", {
		slidesPerView: 'auto',
		spaceBetween: 0,
		navigation: {
			nextEl: ".studio-swiper-button-next",
			prevEl: ".studio-swiper-button-prev",
		},
		1200: {
			slidesPerView: 3.2,
			spaceBetween: 20,
			autoplay: false,
		},
		950: {
			slidesPerView: 2.2,
			spaceBetween: 20,
		},
		650: {
			slidesPerView: 1.2,
			spaceBetween: 20,
		},
	});

	
	/* Homepage Principais Funcionalidades */
	window.onload = function () {

		function setCurrentSlide(ele, index) {
			$(".swiper6 .swiper-slide").removeClass("selected");
			ele.addClass("selected");
		}

		var swiper6 = new Swiper('.swiper6', {
			slidesPerView: 5,
			paginationClickable: true,
			spaceBetween: 10,
			freeMode: true,
			loop: false,
			onTab: function (swiper) {
				var n = swiper6.clickedIndex;
			}
		});
		swiper6.slides.each(function (index, val) {
			var ele = $(this);
			ele.on("click", function () {
				setCurrentSlide(ele, index);
				var teste = index.getAttribute('aria-label');
				var aqui = teste.charAt(0);
				//console.log(aqui);
				if (aqui == 1) {
					$(".swiper7").css("display", "block");
					$(".swiper8").css("display", "none");
					$(".swiper9").css("display", "none");
					/* var f = swiper7.slideTo(aqui - 1, 500, false);
					console.log(f); */
				} else if (aqui == 2) {
					$(".swiper7").css("display", "none");
					$(".swiper8").css("display", "block");
					$(".swiper9").css("display", "none");
					/* swiper8.slideTo(aqui - 2, 500, false); */
				} else {
					$(".swiper7").css("display", "none");
					$(".swiper8").css("display", "none");
					$(".swiper9").css("display", "block");
					/* swiper9.slideTo(aqui - 3, 500, false); */
				}
			});
		});


		var swiper7 = new Swiper('.swiper7', {
			direction: 'horizontal',
			loop: false,
			autoHeight: true,
			slidesPerView: '1',
			spaceBetween: 0,
			navigation: {
				nextEl: ".swiper-btn-next-7",
				prevEl: ".swiper-btn-prev-7",
			},
			fadeEffect: { // Add this
				crossFade: true,
			},
			allowTouchMove: true,
			pagination: {
				el: ".sp7",
				clickable: true
			},
		});

		var swiper8 = new Swiper('.swiper8', {
			direction: 'horizontal',
			loop: false,
			autoHeight: true,
			slidesPerView: '1',
			spaceBetween: 0,
			navigation: {
				nextEl: ".swiper-btn-next-8",
				prevEl: ".swiper-btn-prev-8",
			},
			fadeEffect: { // Add this
				crossFade: true,
			},
			allowTouchMove: true,
			pagination: {
				el: ".sp8",
				clickable: true
			},
		});

		var swiper9 = new Swiper('.swiper9', {
			direction: 'horizontal',
			loop: false,
			autoHeight: true,
			slidesPerView: '1',
			spaceBetween: 0,
			navigation: {
				nextEl: ".swiper-btn-next-9",
				prevEl: ".swiper-btn-prev-9",
			},
			fadeEffect: { // Add this
				crossFade: true,
			},
			allowTouchMove: true,
			pagination: {
				el: ".sp9",
				clickable: true
			},
		});

		/* var Data="Pessoal，Nutrição,Profissional，overbyover,relatedcontent";
		  $(".start").on('click',function(){
			  $(".show").html('');
			  var flag = true,j = 0;
				  //if(flag){
					  //flag = false;
					  (function Data(){
						  if(j < Data.length){
							  setTimeout(function(){
								  $(".show").html(Data.slice(0,j++));
								  Data();
							  },200);
						  }
						  else{
							  $(".show").html(Data);
							  flag = true;
						  }
					  })();
				  //}
		  }); */


	}

	/* var swiper5 = new Swiper(".func-section .func-container", {
		slidesPerView: '1',
		spaceBetween: 0,
		navigation: {
			nextEl: ".func-swiper-button-next",
			prevEl: ".func-swiper-button-prev",
		},
		fadeEffect: { // Add this
			crossFade: true,
		},
		allowTouchMove: true,
		pagination: {
			el: ".swiper-pagination-1",
			clickable: true
		},
	}); */

	windowOnScroll();
	$(window).on('scroll', function () {
		// compensateRellax();
		windowOnScroll();

	});
	$('.toggle-click').on('click', function () {
		$('.toggle-click').removeClass('active');
		$(this).addClass('active');
	});

	/* Páginas FAQS */
	if (window_w >= 820) {
		var stickyUser = $('#sticky-user');
		var sidebarUser;
		if ((stickyUser.length && !Modernizr.touch) || stickyUser.length && is_tablet) {

			sidebarUser = new StickySidebar('#sticky-user', {
				topSpacing: 150,
				bottomSpacing: 0,
				containerSelector: '#has-sticky',
				innerWrapperSelector: '#sticker-inner'
			});

			var targetUser = document.querySelector('#content');

			// create an observer instance
			var observerCheckout = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.type == 'childList') {
						sidebarUser.updateSticky();
					}
				});
			});

			// pass in the target node, as well as the observer options
			observerCheckout.observe(targetUser, {
				attributes: true,
				childList: true,
				subtree: true
			});
		}
	}

	/* FAQS da página Preços/Prices (subscriptions) */
	if (window_w >= 820) {
		var stickyUser = $('#sticky-user-2');
		var sidebarUser;
		if ((stickyUser.length && !Modernizr.touch) || stickyUser.length && is_tablet) {

			sidebarUser = new StickySidebar('#sticky-user-2', {
				topSpacing: 150,
				bottomSpacing: 0,
				containerSelector: '#has-sticky-2',
				innerWrapperSelector: '#sticker-inner-2'
			});

			var targetUser = document.querySelector('#content-2');

			// create an observer instance
			var observerCheckout = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.type == 'childList') {
						sidebarUser.updateSticky();
					}
				});
			});

			// pass in the target node, as well as the observer options
			observerCheckout.observe(targetUser, {
				attributes: true,
				childList: true,
				subtree: true
			});
		}
	}

	/* Blog selecionar categoria */
	$("#categoria-select").change(function (e) {
		e.preventDefault();
		if (parseInt($("#categoria-select").val()) > 0)
			window.location.href = $(this).attr("rel") + "?category=" + $("#categoria-select").val() + '#blog-list';
		else
			window.location.href = $(this).attr("rel") + '#blog-list';
	});

	/* Meter class active current na item list 'tutorials' e remover na do 'blog' */
	var url = window.location.search;
	if (url == '?category=11') {
		$('.menu-container .nav .last .sub-menu ul li').removeClass('active current');
		$('.menu-container .nav .last .sub-menu ul .tutorial').addClass('active current');

		$('.footer-secondary li').removeClass('active current');
		$('.footer-secondary .tutorial').addClass('active current');
	} else {
		$('.menu-container .nav .last .sub-menu ul .tutorial').removeClass('active current');
		$('.footer-secondary .tutorial').removeClass('active current');
	}

	/**
* Abrir e fechar o menu
*/
	$('#toggle-menu').on('click', function () {
		var el = $(this);
		if (el.hasClass('opened')) {
			el.removeClass('opened');
			$('#menu').removeClass('show');
			blockScroll(0);
		} else {
			el.addClass('opened');
			$('#menu').addClass('show');
			blockScroll(1);
		}
	});

	$('.app-slider').slick({
		arrows: false,
		fade: true,
		dots: true,
		draggable: false,
		autoplay: false,
		infinite: false,
		pauseOnHover: true,
		pauseOnDotsHover: true,
		prevArrow: false,
		nextArrow: false,
		responsive: [
		]
	});
	$('.homepage-slider').slick({
		arrows: false,
		fade: true,
		dots: true,
		appendDots: '.homepage-slick-dots',
		draggable: false,
		autoplay: true,
		autoplaySpeed: 8000,
		infinite: true,
		pauseOnHover: true,
		pauseOnDotsHover: true,
		prevArrow: false,
		nextArrow: false,
		responsive: [
		]
	});


	if ($('.tippy').length) {
		tippy('.tippy', {
			content: (reference) => reference.getAttribute('title'),
		});
	}

	if ($('.tippy-white').length) {
		tippy('.tippy-white', {
			theme: 'light',
			content: (reference) => reference.getAttribute('title'),
		});
	}


});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}

/**
 * Window on scroll
 */
function windowOnScroll() {
	if ($(window).scrollTop() > 45 && $('body').hasClass('big') && $('body').hasClass('should-big')) {
		$('.should-big').removeClass('big');
	} else if ($(window).scrollTop() <= 45 && !$('body').hasClass('big') && $('body').hasClass('should-big')) {
		$('.should-big').addClass('big');
	}
	if ($(window).scrollTop() > 45 && !$('body').hasClass('scrolled')) {
		$('body').addClass('scrolled');
	} else if ($(window).scrollTop() <= 45 && $('body').hasClass('scrolled')) {
		$('body').removeClass('scrolled');
	}
}